module.exports = __webpack_public_path__ + "img/17_60.fc9569a5.png";